<template>

  <div class="wrap">
    <!-- 导航 -->
    <div class="page-header">
      <Nav :activeId="activeId" />
    </div>

    <!-- 历程 -->
    <div class="section-one self-bg" >

      <div class="nav-bar">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span>百年传承
        </div>
        <!-- <img src="../../img/explore/nav-top.png" class="product explore" /> -->
      </div>
      
      <img src="../../img/explore/title1.png" class="explore-title1" />
      <img src="../../img/explore/title2.png" class="explore-title2" />

      <!-- <img src="../../img/explore/bg2-title.png" class="title" /> -->
      <img src="../../img/explore/icon-up.png" class="icon-up" @click="onUp" />

      <div class="explore-timeline">
        <img src="../../img/explore/timeline.png" class="" />
      </div>

      <img src="../../img/explore/icon-down.png" class="icon-down" @click="onDown" />
    </div>

    <!-- 尾部 -->
    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  },
  methods: {
    onUp() {
      let step = 100;
      let Box = document.querySelector(".explore-timeline");
      // Box.scrollTo({
      //   top: 200,
      //   behavior: "smooth",
      // });
      this.stopScroll();
      // this.timer = setInterval(() => {
        Box.scrollTop += step;
        // Box.scrollTo({
        //   behavior: "smooth",
        // });
        // Box.behavior += step;
      // }, 100);
    },
    onDown() {
      let step = 100;
      let Box = document.querySelector(".explore-timeline");
      // Box.scrollTo({
      //   top: 200,
      //   behavior: "smooth",
      // });
      this.stopScroll();
      // this.timer = setInterval(() => {
      Box.scrollTop -= step;
      // let Box = document.querySelector(".explore-timeline");
      // Box.scrollTo({
      //   top: -Box.offsetTop,
      //   behavior: "smooth",
      // });
    },
    stopScroll() {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped lang="less">
.self-bg {
  min-height: 2000px;
  background: url('../../img/explore/bg.jpg') center top no-repeat;
  // background-size: 100% 2000px;
  background-size: 100%;
  // padding: 960px 0 200px;
}
.explore-title1 {
  width: 1103px;
  height: 93px;
  margin: 0 auto;
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
}
.explore-title2 {
  width: 332px;
  height: 82px;
  margin: 0 auto;
  position: absolute;
  top: 350px;
  left: 0;
  right: 0;
}
// 探索
// .explore-info {
//     width: 1100px;
//     height: 821px;
//     margin: 0 auto;
//     display: flex;
//     justify-content: space-between;
//     align-items: flex-end;
//     position: absolute;
//     top: 150px;
//     left: 0;
//     right: 0;
//     &.info2 {
//         top: 1300px;
//     }
//     .pic-1 {
//         width: 523px;
//         height: 821px;
//     }
//     .text-1 {
//         width: 498px;
//         height: 264px;
//     }

//     .text-2 {
//         width: 509px;
//         height: 390px;
//     }
//     .pic-2 {
//         width: 520px;
//         height: 821px;
//     }
// }
.explore-line {
    width: 1117px;
    height: 3px;
    margin: 0 auto;
    position: absolute;
    top: 1150px;
    left: 0;
    right: 0;
    img {
      width: 100%;
      height: 100%;
    }
}
// Up
.icon-up {
    width: 54px !important;
    height: 54px;
    margin: 0 auto;
    position: absolute;
    top: 500px;
    left: 0;
    right: 0;
    cursor: pointer;
}
// Down
.icon-down {
    width: 54px !important;
    height: 54px;
    margin: 0 auto;
    position: absolute;
    top: 1800px;
    left: 0;
    right: 0;
    cursor: pointer;
}
.explore-timeline {
    // width: 1291px;
    width: 948px;
    height: 1000px;
    // height: 960px;
    margin: 0 auto;
    position: absolute;
    top: 650px;
    left: 0;
    right: 0;
    overflow-y: auto;
    // overflow: hidden;
}
</style>